import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Response } from '@ui/src';
import { paymentTypesApi } from '../services/payment-types';
import { PaymentType } from '../../types';

export interface PaymentTypesState {
  paymentTypes?: PaymentType[];
  paymentType?: PaymentType;
  isSuccess?: boolean;
}

const initialState: PaymentTypesState = {};

export const paymentTypesSlice = createSlice({
  name: 'paymentTypes',
  initialState,
  reducers: {
    setPaymentTypes: (state, action: PayloadAction<PaymentType[]>) => {
      state.paymentTypes = action.payload;
    },
    updatePaymentTypes: (state, action: PayloadAction<PaymentType[]>) => {
      state.paymentTypes = action.payload;
    },
    setIsSuccess: (state) => {
      state.isSuccess = false;
    },
    clearPaymentTypeState: (state) => {
      state.paymentType = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      paymentTypesApi.endpoints.getExchangePaymentTypes.matchFulfilled,
      (state, action: PayloadAction<Response<PaymentType>>) => {
        state.paymentTypes = action?.payload?.data?.edges?.map(
          (item) => item.node,
        );
      },
    );
    builder.addMatcher(
      paymentTypesApi.endpoints.getPaymentType.matchFulfilled,
      (state, action: PayloadAction<{ data: PaymentType }>) => {
        state.paymentType = action.payload.data;
      },
    );
    builder.addMatcher(
      paymentTypesApi.endpoints.paymentTypeStatusesBatchUpdate.matchPending,
      (state) => {
        state.isSuccess = false;
      },
    );
    builder.addMatcher(
      paymentTypesApi.endpoints.paymentTypeStatusesBatchUpdate.matchFulfilled,
      (state, action: PayloadAction<{ data: PaymentType[] }>) => {
        state.paymentTypes = state?.paymentTypes?.map((item) => {
          let result = { ...item };

          const currentPaymentType = action?.payload?.data?.find(
            (paymentType) => paymentType.id === result.id,
          );

          if (currentPaymentType && result.id === currentPaymentType.id) {
            result = currentPaymentType;
          }

          return result;
        });

        state.isSuccess = true;
      },
    );
    builder.addMatcher(
      paymentTypesApi.endpoints.editPaymentTypeCurrencies.matchPending,
      (state) => {
        state.isSuccess = false;
      },
    );
    builder.addMatcher(
      paymentTypesApi.endpoints.editPaymentTypeCurrencies.matchFulfilled,
      (state, action: PayloadAction<{ data: PaymentType }>) => {
        state.paymentType = action.payload.data;

        state.paymentTypes = state.paymentTypes?.map((item) => {
          let result = { ...item };

          if (result.id === action?.payload?.data?.id) {
            result = action.payload.data;
          }

          return result;
        });

        state.isSuccess = true;
      },
    );
  },
});

export const {
  updatePaymentTypes,
  clearPaymentTypeState,
  setPaymentTypes,
  setIsSuccess,
} = paymentTypesSlice.actions;

export default paymentTypesSlice.reducer;
